import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import ParsePaymentCardForm from '../components/forms/ParsePaymentCardForm';
import { selectCurrentCompany, getCompanyByReference } from '../store/companySlice';
import { inIframe, isMobile } from '../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  alertContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: ' center',
    marginBottom: 25,
  },
  alertContainerInner: {
    display: 'inline-block',
  },
  alignCenter: {
    textAlign: 'center',
  },
}));

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export default function VerificationNext() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const company = useSelector(selectCurrentCompany);
  const reference = query.get('reference');

  useEffect(() => {
    if (reference) {
      dispatch(getCompanyByReference({ reference }));
    }
  }, [dispatch, reference]);

  return company
    ? (
      (
        <>
          { (isMobile() || (company && company.customAttributes && company.customAttributes.enableDesktopUploads))
            ? (
              <>
                {
                inIframe()
                  ? (
                    <Grid container className={classes.content}>
                      <Grid item xs={12}>
                        <ParsePaymentCardForm identityReference={reference} />
                      </Grid>
                    </Grid>
                  )
                  : (
                    <Paper className={classes.root} elevation={1}>
                      <Grid container className={classes.content}>
                        <Grid item xs={12}>
                          <ParsePaymentCardForm identityReference={reference} />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
              }
              </>
            )
            : (
              <>
                <Grid container className={classes.content}>
                  <Grid item xs={12}>
                    <div>
                      <h1 className={classes.alignCenter}>Open this window on a mobile device</h1>
                      <div className={classes.alertContainer}>
                        <div className={classes.alertContainerInner}>
                          <Alert severity="warning">
                            A mobile device is required to complete the verification process.
                          </Alert>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
        </>
      )
    )
    : (
      <>
        <Grid container className={classes.content}>
          <Grid item xs={12}>
            <div>
              <div className={classes.alertContainer}>
                <div className={classes.alertContainerInner}>
                  <div className={classes.loader}>
                    <CircularProgress size={100} />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
}
